import React, { useContext } from 'react';
import { customerApplicationContext } from 'helpers/services';
import NavBar from './NavBar';
import theme from 'assets';

let PrivateLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    let appService = useContext(customerApplicationContext);

    return (
        <>
            {appService.isLoading === false &&
                <>
                    <NavBar />
                    <div
                        style={{
                            marginLeft: 16,
                            marginRight: 16,
                            marginTop: 8,
                            marginBottom: 8,
                            [theme.breakpoints.down('lg')]: {
                                marginLeft: 8,
                                marginRight: 8,
                            },
                        }}
                    >
                        {children}
                    </div>
                </>
            }
        </>
    );
}

export default PrivateLayout;